import { IDashboardState } from "@/core/interfaces/dashboard.interface";

const state: IDashboardState = {
  isInsightsLoading: false,
  insights: null,
  bookingAggregate: null,
  dailyFlightChartData: null,
  dailyHotelChartData: null,
};

export default state;
